import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "tw-flex-auto headlines--headline-06 tw-text-core-primary-10 tw-p-4",
  "data-test": "password-reset-callout-title"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "tw-mt-4",
  "data-test": "password-reset-callout-message"
}

import i18n from 'frontcore/i18n'
import Modal from 'frontcore/components/Modal.vue'
import { AuthorizationStorageFactory } from 'frontcore/domain/authorization/store/factory'
import { computed, onMounted } from 'vue'

interface Props {
  userId: number
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordUpdateCallout',
  props: {
    userId: {}
  },
  setup(__props: any) {

const props = __props

const { t } = i18n.global

const storage = AuthorizationStorageFactory.build()

onMounted(() => {
  storage.clear()
})

const redirect = () => {
  const url = `${MPS_URL}/update-password/?user=${props.userId}&continue=${window.location}`
  window.location.assign(url)
}

const actionButtons = computed(() => {
  return [
    {
      label: t('common.messages.password_reset_callout_button'),
      onClickHandler: redirect,
      dataTest: 'password-reset-callout-redirect-button',
    },
  ]
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, { actionButtons: actionButtons.value }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('common.messages.password_reset_callout_title')), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: require('../../../assets/images/reset_icon.svg'),
          alt: "Reset icon",
          class: "center-block"
        }, null, 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('common.messages.password_reset_callout_message')), 1)
      ])
    ]),
    _: 1
  }, 8, ["actionButtons"]))
}
}

})